import type { ValidationHandler } from "./ValidationHandler";

export const combineValidations = (
  ...validators: Array<
    ValidationHandler | ValidationHandler[] | boolean | undefined
  >
) => {
  return ((...args) => {
    const flattened = validators.flat();
    for (const validator of flattened) {
      if (typeof validator !== "function") {
        continue;
      }
      const error = validator(...args);
      if (error) {
        return error;
      }
    }
    return undefined;
  }) as ValidationHandler;
};

/**
 * @deprecated
 */
export default combineValidations;
